import { Link, useLocation, useSearchParams } from 'react-router';
import { Logo } from './Logo';
import { SearchBox } from './SearchBox';
import { UserBox } from './UserBox';

export function Header() {
  const [params] = useSearchParams();
  const { pathname } = useLocation();
  // The 2009 landing page owns the whole viewport; it carries its own search box and menu.
  if (pathname === '/') return null;
  return (
    <>
      <header className="site-header">
        <div className="inner">
          <Link to="/" className="logo-link">
            <Logo size="small" />
          </Link>
          <SearchBox key={params.get('q') ?? ''} initial={params.get('q') ?? ''} />
          <UserBox />
        </div>
      </header>
      <nav className="nav-row" aria-label="Browse">
        <div className="inner">
          <Link to="/browse/quest">Quests</Link>
          <Link to="/browse/item">Items</Link>
          <Link to="/browse/npc">NPCs</Link>
          <Link to="/browse/object">Objects</Link>
          <Link to="/browse/zone">Zones</Link>
          <Link to="/browse/ability">Classes</Link>
          <Link to="/browse/recipe">Professions</Link>
          <Link to="/submit">Submit</Link>
          <Link to="/addon">Addon</Link>
          <Link to="/build">Build</Link>
        </div>
      </nav>
    </>
  );
}
